export class PayrollJournalEntry {
  ChangedBy: string;
  ClientCode: string;
  DateChanged: Date;
  Description: string;
  Id: number;
  SequenceNumber: number;
  PayrollSchedule: string;
  PayDate: Date;
  PeriodEndDisplay: Date;
}

export class PayrollJournalSearchConfig {
  ChangedBy: string;
  ClientCode: string;
  Description: string;
  PageNumber: number = 1;
  PageSize: number = 25;
  PayDate: string;
  SequenceNumber: number;
  PayrollSchedule: string;
  PeriodEndDate: string;
  SortKey: string;
  SortDirection: string;
  EarliestDate: Date;
  LatestDate: Date;
}
